import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=efc8742a&"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports